import {
  fileCopy,
  checkDropboxPath,
  createDropboxFolder
} from '../services/dropboxRequests'
import {getLocal, setLocal} from './storage'
import {sleep} from '../shared/utils'
// const PHOTOS = 'photos'


class CopyQueueManager {
  constructor(args){
    // this.user = args.user
    // console.log('got leftover queue in PhotoManager', q)
    this.displayMessage = function(){}
    // this.photosToCheck = 0
    // this.queue = {}
    // this.timesChecked = 0
    // this.setQueue()
  }

  setDisplayProgress(fn){
    this.displayProgress = fn
  }

  async copyFile(from, to, token){
    this.token = token
    if(this.queueLock) await this.awaitQueueLock()
    this.queueLock = true
    let curQueue = await getLocal('copyQueue')||[]
    let testQ = curQueue.filter(itm=>(itm.from===from&&itm.to===to))
    if(!testQ.length){
      // curQueue = await getLocal('copyQueue')
      await setLocal('copyQueue', [...curQueue, {from, to}])
      this.queueLock = false
      if(!this.executing){
        this.executeCopies()
      }
    }
    console.log('added item to copy queue', from, to)
  }

  async awaitQueueLock(){
    return new Promise((resolve)=>{
      while(this.queueLock){
        // setTimeout(x=>{console.log('waiting for queueLock')}, 100)
        console.log('waiting for queueLock')
        sleep(100)
      }
      resolve()
    })
  }

  async executeCopies(){
    console.log('COPY EXECUTION')
    this.executing=true
    if(this.queueLock) await this.awaitQueueLock()


    let curQueue = await getLocal('copyQueue')
    this.displayMessage(`Copying ${curQueue.length} photos on Dropbox`)
    let initLength = curQueue.length
    let dlIdx = 1
    while(curQueue.length){
      if(this.queueLock) await this.awaitQueueLock()
      curQueue = await getLocal('copyQueue')
      this.displayMessage(`Copying photo ${dlIdx} of ${initLength}.`)

      console.log('got curQueue', curQueue)
      for(let qi of curQueue){
        // let fromDir = qi.from.split('/').slice(0, qi.from.split('/').length-2 )
        let toDir = qi.to.split('/').slice(0, qi.to.split('/').length-2 ).join('/')
        let fileExists = await checkDropboxPath(qi.from, this.token)
        let toFileExists = await checkDropboxPath(qi.to, this.token)
        let toDirExists = await checkDropboxPath(toDir, this.token)
        try {
          if(!toDirExists) await createDropboxFolder(toDir, this.token)
        } catch(e) {
          console.log('failed to create dropbox folder!', e)
        }
        console.log('copying', qi)
        if(toFileExists){
          this.displayMessage(`Destination file exists, skipping copy, ${dlIdx} of ${initLength}`)
          if(dlIdx<initLength)++dlIdx
          continue
        }
        if(fileExists) {
          console.log('copy source file exists, attempt to copy remotely')
          try {
            await fileCopy(qi.from, qi.to, this.token)
          } catch(e) {
            console.log('failed to copy', e)
          }
        }
        if(dlIdx<initLength)++dlIdx
        this.displayMessage(`Copying photo ${dlIdx} of ${initLength}.`)
      }

      if(this.queueLock) await this.awaitQueueLock()
      this.queueLock = true
      let newQueue = await getLocal('copyQueue')
      console.log('got newQueue', newQueue)
      let propQueue = []
      for(let nqi of newQueue){
        let found =false
        for(let qi of curQueue){
          if((nqi.from===qi.from)&&(nqi.to===qi.to)) found = true
        }
        if(!found)propQueue.push(nqi)
      }

      curQueue = propQueue
      // curQueue = newQueue.filter(itm=>{
      //   return curQueue.filter(elm=>((itm.from!==elm.from)&&(itm.to!==elm.to))).length
      // })
      // if(this.queueLock) await this.awaitQueueLock()
      initLength += curQueue.length
      console.log('setting current queue after filtering', curQueue)
      await setLocal('copyQueue', curQueue)
      this.queueLock=false
    }
    this.displayMessage(`Copied ${dlIdx} photos.`)
    this.executing = false
  }



  setDisplayMessage(fn){
    this.displayMessage = fn
  }



  getPhotoUpdateCallback(callback){

  }

}

export {CopyQueueManager}
